/**
 * 한국 전화번호 입력 자동 하이픈 포맷터.
 *
 * 정책: 사용자가 한 글자 칠 때마다 자릿수 보고 자동으로 하이픈 삽입.
 *   - 010-1234-5678  (휴대폰)
 *   - 02-XXXX-XXXX   (서울 8자리) / 02-XXX-XXXX (서울 7자리, 구식)
 *   - 0XX-XXXX-XXXX  (지역 8자리) / 0XX-XXX-XXXX (지역 7자리)
 *   - 1588-XXXX 등 대표번호도 어느 정도 자연스럽게 잡힘
 *
 * 모든 폼(직원·연락처·거래처 등)에서 같은 표시 규칙을 쓰기 위해 공용 유틸로 둠.
 *
 * @param {string} raw — 원시 입력
 * @returns {string} 하이픈이 자동 삽입된 표시용 문자열
 */
export function formatPhone(raw) {
    if (raw == null) return "";
    const d = String(raw).replace(/\D/g, "").slice(0, 11);
    if (d.length === 0) return "";

    // 서울 (02) — 2 + 3~4 + 4
    if (d.startsWith("02")) {
        if (d.length <= 2)  return d;
        if (d.length <= 5)  return `${d.slice(0, 2)}-${d.slice(2)}`;            // 02-XXX
        if (d.length === 9) return `${d.slice(0, 2)}-${d.slice(2, 5)}-${d.slice(5)}`;     // 02-XXX-XXXX
        if (d.length <= 9)  return `${d.slice(0, 2)}-${d.slice(2, 5)}-${d.slice(5)}`;
        return `${d.slice(0, 2)}-${d.slice(2, 6)}-${d.slice(6)}`;               // 02-XXXX-XXXX
    }

    // 그 외 (휴대폰 010 / 지역 031 등) — 3 + 3~4 + 4
    if (d.length <= 3) return d;
    if (d.length <= 6) return `${d.slice(0, 3)}-${d.slice(3)}`;
    if (d.length === 10) return `${d.slice(0, 3)}-${d.slice(3, 6)}-${d.slice(6)}`;        // 0XX-XXX-XXXX
    if (d.length <= 10)  return `${d.slice(0, 3)}-${d.slice(3, 6)}-${d.slice(6)}`;
    return `${d.slice(0, 3)}-${d.slice(3, 7)}-${d.slice(7)}`;                            // 0XX-XXXX-XXXX
}

/**
 * 표시값(또는 사용자 입력값)에서 숫자만 뽑아내 normalized 값을 얻는다.
 * 백엔드에 보내거나 검색 시 비교할 때 사용.
 */
export function digitsOnly(s) {
    return s ? String(s).replace(/\D/g, "") : "";
}
